import React, { useEffect, useState } from 'react';

import { isB2C } from '@/core/settings/utils';
import { Input } from '@/core/tamagoshi/Input/Input';
import { Button } from '@/core/tamagoshiv2/components/Button/Button';
import { Typography } from '@/core/tamagoshiv2/components/Typography/Typography';
import {
  surfaceInputDisclaimer,
  surfaceInputSubmit,
  surfaceInputText,
} from '@/productDiscovery/ProductPage/common/modules/QuantitySelector/translations';
import { useQuantitySelector } from '@/productDiscovery/ProductPage/common/modules/QuantitySelector/useQuantitySelector';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';

import styles from './styles.module.scss';

export const M2 = 'm²';
const squareMeterUnit = [M2, 'square meter']; // TODO: MSF convert square meter to m², remove m² when MSF is done

export const SurfaceInput: React.FC = () => {
  const { unitCount, price } = useDetail();
  const { totalStock, onStepperChange, quantity } = useQuantitySelector();
  const [surface, setSurface] = useState<number>(
    Math.floor(quantity * unitCount),
  );

  useEffect(() => {
    setSurface(Math.floor(quantity * unitCount));
  }, [quantity, unitCount]);

  if (!unitCount) {
    return null;
  }

  const onClick = () => {
    onStepperChange(Math.ceil(surface / unitCount));
  };

  if (
    !squareMeterUnit.includes(price.measurementPrice?.measurementUnit || '')
  ) {
    return null;
  }

  const maxSurface = totalStock ? totalStock * unitCount : unitCount;
  return (
    <div className={styles.container}>
      <Typography variant="body2" type="semiBold">
        {surfaceInputText}
      </Typography>
      <div className={styles.row}>
        <div className={styles.inputContainer}>
          <Input
            aria-label="surface"
            type="number"
            value={surface}
            onChange={(e) => setSurface(Number(e.target.value))}
            className={styles.input}
            placeholder="0"
            min="0"
            max={maxSurface}
          />
          <Typography variant="small" className={styles.unit}>
            m²
          </Typography>
        </div>
        <Button
          content={surfaceInputSubmit}
          className={styles.submitButton}
          disabled={!surface}
          onClick={onClick}
        />
      </div>
      {isB2C() && (
        <Typography variant="small">{surfaceInputDisclaimer}</Typography>
      )}
    </div>
  );
};
